import '@babel/polyfill'
import Vue from 'vue'
import './plugins/axios'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import dictaComponents from 'dicta-vue-components'
import {initializeUndoRedo} from 'shared/UndoRedo'
import {dropboxInitialize} from 'shared/dropbox/dropbox_utils'
import {DocumentManager} from './DocumentManager'

Vue.config.productionTip = false

const isDev = process.env.NODE_ENV === "development"
Vue.config.performance = isDev

Vue.use(dictaComponents, { hebrew: true, useBodyClass: true })
Vue.use(VueCookies)

import VueHotkey from 'v-hotkey'
Vue.use(VueHotkey)

initializeUndoRedo({
  store,
  undoableCommits: ['REWRITE_WORD_IN_WORKING_ARRAY', 'SPLICE_WORDS_IN_WORKING_ARRAY'],
  baseStateCommits:  ['BUILD_STATE', 'STORE_ALL_WORKING_NIKUD'],
  emptyStateCommit: 'emptyState'
})

import triggerServerUpdate from './js/triggerServerUpdate'
import {AppConfig} from './appConfig'
import {loadLocalData} from './js/localData'

if (AppConfig.OFFER_DROPBOX) {
  let dropboxInitObj = {
    documentManager: DocumentManager,
    store: store,
    toolName: 'abbreviation'
  }
  if (AppConfig.SERVER_UPDATE.ALWAYS_TRIGGER) {
    dropboxInitObj['onCompletionCallback'] = triggerServerUpdate
    dropboxInitObj['noCompletingInProjects'] = true // since the callback's currently only run from "save"
  }
  if (AppConfig.SPECIAL_AUTOSAVE_INTERVAL) dropboxInitObj['autoSaveInterval'] = AppConfig.SPECIAL_AUTOSAVE_INTERVAL
  dropboxInitialize(dropboxInitObj)
}

router.onReady(() => {
  loadLocalData(router.currentRoute.name === 'nikud-edit')
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
